<template>
  <div>
    <page-header
      :actions="headerActionConfig"
      :on-return="back"
      :page="pageConfig"
    />
    <board class="mb-4" :details="boardData" />
    <validation-observer ref="admissionManagementRef" novalidate tag="form">
      <b-tabs
        v-if="isSignHubActive"
        class="mt-3"
        nav-class="custom-nav-container"
        no-nav-style
      >
        <b-tab active title="Informe de Alta/Baja">
          <div class="my-4">
            <section-title has-line title="Mantenimiento de Admisión" />
            <div class="row ml-2 pr-3">
              <div class="col-md-3 mt-1">
                <validation-provider v-slot="{ errors }" rules="required">
                  <div class="color-secondary-6 font-14">
                    Nivel:
                  </div>
                  <div class="bg-gray-9 p-2 rounded mt-2">
                    <custom-radio
                      v-model="model.selectedLevel"
                      container-class="d-flex justify-content-between"
                      :is-disabled="isReadOnly"
                      is-inline
                      name="rbType"
                      :options="rbOptions"
                      @input="onLevelChange"
                    />
                  </div>
                  <error
                    v-if="errors[0]"
                    message="Favor seleccionar el nivel."
                    variant="no-border"
                  />
                </validation-provider>
              </div>
              <div class="col-md-2">
                <validation-provider v-slot="{ errors }" rules="required">
                  <custom-date-picker
                    v-model="model.effectiveDate"
                    class="w-100"
                    custom-error-msg="Favor seleccionar la fecha de efectividad."
                    :disabled="isReadOnly"
                    :error="errors[0]"
                    label="Efectivo:"
                    :max-date="maxDate"
                    :min-date="minDate"
                    placeholder="DD/MM/YYYY"
                  />
                </validation-provider>
              </div>
              <div class="col-md-2">
                <validation-provider v-slot="{ errors }" rules="required">
                  <custom-date-picker
                    v-model="model.discussionMinutesDate"
                    class="w-100"
                    custom-error-msg="Favor seleccionar la fecha discusión minuta."
                    :disabled="isReadOnly"
                    :error="errors[0]"
                    label="Fecha Discusión Minuta:"
                    :max-date="maxDate"
                    :min-date="minDate"
                    placeholder="DD/MM/YYYY"
                  />
                </validation-provider>
              </div>
              <div class="col-md-5">
                <div class="d-flex align-items-end">
                  <div class="flex-grow-1">
                    <validation-provider v-slot="{ errors }" rules="required">
                      <custom-drop-down
                        v-model="model.selectedReason"
                        custom-error-msg="Favor seleccionar la razón."
                        :disabled="isReadOnly"
                        :error="errors[0]"
                        fieldkey="id"
                        fieldname="name"
                        label="Razón:"
                        :options="reasons"
                        placeholder="Seleccione"
                      />
                    </validation-provider>
                  </div>
                </div>
                <div v-if="showReasonComment" class="">
                  <validation-provider v-slot="{ errors }" rules="required">
                    <custom-text-area
                      id="txtCommentDenyPayment"
                      v-model="model.dropReasonComment"
                      custom-error-msg="Favor escribir un comentario."
                      :disabled="isReadOnly"
                      :error="errors[0]"
                      label="Razón que limita el ofrecimiento:"
                      :maxlength="500"
                      show-char-count
                    />
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="col-md-12 mt-4">
              <div v-if="showRecommendationsComment">
                <validation-provider v-slot="{ errors }" rules="required">
                  <custom-text-area
                    id="txtRecommendationsComment"
                    v-model="model.recommendationsComment"
                    :count-classes="['d-block', 'small-counter', 'text-right']"
                    custom-error-msg="Favor de documentar las recomendaciones para la escuela y hogar."
                    :disabled="isReadOnly"
                    :error="errors[0]"
                    label="Recomendaciones para la escuela y hogar (plan de seguimiento):"
                    :maxlength="3000"
                    show-char-count
                  />
                </validation-provider>
              </div>
            </div>
            <div class="col-md-12 mt-4">
              <div>
                <validation-provider v-slot="{ errors }" rules="required">
                  <custom-text-area
                    id="txtResult"
                    v-model="model.results"
                    :count-classes="['d-block', 'small-counter', 'text-right']"
                    custom-error-msg="Favor escribir los resultados."
                    :disabled="isReadOnly"
                    :error="errors[0]"
                    label="Resultados:"
                    :maxlength="3000"
                    show-char-count
                  />
                </validation-provider>
              </div>
            </div>
            <div v-if="showLocationFields" class="row mt-3 ml-2">
              <div class="col-md-12">
                <hr />
              </div>
              <div class="col">
                <validation-provider v-slot="{ errors }" rules="required">
                  <custom-drop-down
                    v-model="model.selectedMunicipality"
                    custom-error-msg="Favor seleccionar municipio."
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    label="Municipio:"
                    :options="municipalities"
                    placeholder="Seleccione"
                    @input="onMunicipalityChange"
                  />
                </validation-provider>
              </div>
              <div class="col">
                <validation-provider v-slot="{ errors }" rules="required">
                  <custom-drop-down
                    v-model="model.selectedLocation"
                    custom-error-msg="Favor seleccionar lugar de servicio."
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    label="Lugar de Servicio:"
                    :options="locations"
                    placeholder="Seleccione"
                    @input="onLocationChange"
                  />
                </validation-provider>
              </div>
              <div class="col">
                <validation-provider v-slot="{ errors }" rules="required">
                  <custom-drop-down
                    v-model="model.selectedSpecialist"
                    custom-error-msg="Favor seleccionar especialista."
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    label="Especialista:"
                    :options="specialists"
                    placeholder="Seleccione"
                  />
                </validation-provider>
              </div>
            </div>
            <div v-if="!showLocationFields" class="mt-5">
              <section-title has-line title="Documentos Anejados" />
              <div
                v-for="(item, index) in requiredDocuments"
                :key="`document-row-${index}`"
                class="row bg-secondary-3 rounded p-3 mb-3 ml-1 mr-0"
              >
                <div class="col-md-6">
                  <div class="color-gray-6 font-14 font-weight-normal">
                    Tipo de Documento:
                  </div>
                  <div class="color-black font-16 font-weight-normal">
                    {{ item.documentTypeName }}
                  </div>
                </div>
                <div class="col-md-6 d-flex justify-content-end">
                  <div v-if="isDropTypeDocument(item)">
                    <div v-if="hasDownloadedAdmissionTemplate">
                      <span
                        class="color-gray-6 font-14 font-weight-normal mr-3 mt-2"
                      >
                        Documento:
                      </span>
                      <validation-provider
                        v-slot="{ errors }"
                        :rules="{ required: item.isRequired }"
                      >
                        <custom-file-input
                          ref="attachedDocument"
                          v-model="item.selectedDocument"
                          :accept="'.pdf'"
                          :attachment-id="item.documentId"
                          custom-error-msg="Favor de anejar un documento."
                          display-style="normal"
                          :error="errors[0]"
                          label-position="left"
                          required
                        />
                      </validation-provider>
                    </div>

                    <div v-else>
                      <action-button
                        :id="'admission-drop-type-template' + index"
                        class="bg-green border-green mt-1"
                        i="fas fa-file-download text-white mr-n1 pr-1"
                        @click="downloadAdmissionDropTypeTemplate"
                      />
                    </div>
                  </div>
                  <div v-else>
                    <div
                      v-if="
                        !item.isEditing &&
                          model.documents.some(
                            (x) => x.documentTypeId == item.documentTypeId
                          )
                      "
                    >
                      <action-button
                        class="bg-green border-green mt-1 mr-2"
                        i="fas fa-file-download text-white mr-n1 pr-1"
                        @click="downloadFileByType(item.documentTypeId)"
                      />
                      <action-button
                        v-if="isEditing"
                        class="bg-green border-green mt-1"
                        i="fas fa-edit text-white mr-n1"
                        @click="() => (item.isEditing = true)"
                      />
                    </div>
                    <div v-else>
                      <span
                        class="color-gray-6 font-14 font-weight-normal mr-3 mt-2"
                      >
                        Documento:
                      </span>
                      <validation-provider
                        v-slot="{ errors }"
                        :rules="{ required: item.isRequired }"
                      >
                        <custom-file-input
                          ref="attachedDocument"
                          v-model="item.selectedDocument"
                          :accept="'.pdf'"
                          :attachment-id="item.documentId"
                          custom-error-msg="Favor de anejar un documento."
                          display-style="normal"
                          :error="errors[0]"
                          label-position="left"
                          required
                        />
                      </validation-provider>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab v-if="showSignTab && !isEditing" title="Firmas">
          <div class="my-4">
            <sign-plan
              :key="admissionId"
              ref="signPlanRef"
              :disabled="isElectronicDisabled"
              :is-electronic-signature.sync="model.isElectronicSignature"
              question-label="¿Cuál será el mecanismo que se estará utilizando para firmar la Informe de Alta/Baja?"
            />
            <div class="mt-4">
              <div v-if="hasSelectMechanisManuscript">
                <section-title has-line title="Documento" />
                <div
                  v-if="highLowInformDocument"
                  class="row bg-secondary-3 rounded p-3 mb-3 ml-1 mr-0"
                >
                  <div class="col-md-6">
                    <div class="color-gray-6 font-14 font-weight-normal">
                      Tipo de Documento:
                    </div>
                    <div class="color-black font-16 font-weight-normal">
                      {{ highLowInformDocument.documentTypeName }}
                    </div>
                  </div>
                  <div class="col-md-6 d-flex justify-content-end">
                    <action-button
                      v-if="hasManuscriptDocUploaded"
                      class="bg-green border-green mt-1"
                      i="fas fa-file-download text-white mr-n1 pr-1"
                      @click="
                        downloadFileByType(highLowInformDocument.documentTypeId)
                      "
                    />
                    <div v-else-if="hasDownloadedAdmissionTemplate">
                      <span
                        class="color-gray-6 font-14 font-weight-normal mr-3 mt-2"
                      >
                        Documento:
                      </span>
                      <validation-provider
                        v-slot="{ errors }"
                        :rules="{ required: true }"
                      >
                        <custom-file-input
                          ref="highLowInform"
                          v-model="highLowInformDocument.selectedDocument"
                          :accept="'.pdf'"
                          :attachment-id="highLowInformDocument.documentId"
                          custom-error-msg="Favor de anejar un documento."
                          display-style="normal"
                          :error="errors[0]"
                          label-position="left"
                          required
                        />
                      </validation-provider>
                    </div>
                    <action-button
                      v-else
                      class="bg-green border-green mt-1"
                      i="fas fa-file-download text-white mr-n1 pr-1"
                      @click="downloadAdmissionDropTypeTemplate"
                    />
                  </div>
                </div>
              </div>
              <signature-hub-info
                v-else-if="hasSelectMechanismElectronic"
                :signature-info="signatureHubInfo"
                @configure-sign="handleConfigureSignatures"
              />
            </div>
          </div>
        </b-tab>
      </b-tabs>
      <div v-else>
        <section-title has-line title="Mantenimiento de Admisión" />
        <div class="row ml-2">
          <div class="col-md-3 mt-1">
            <validation-provider v-slot="{ errors }" rules="required">
              <div class="color-secondary-6 font-14">
                Nivel:
              </div>
              <div class="bg-gray-9 p-2 rounded mt-2">
                <custom-radio
                  v-model="model.selectedLevel"
                  container-class="d-flex justify-content-between"
                  is-inline
                  name="rbType"
                  :options="rbOptions"
                  @input="onLevelChange"
                />
              </div>
              <error
                v-if="errors[0]"
                message="Favor seleccionar el nivel."
                variant="no-border"
              />
            </validation-provider>
          </div>
          <div class="col-md-2">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-date-picker
                v-model="model.effectiveDate"
                class="w-100"
                custom-error-msg="Favor seleccionar la fecha de efectividad."
                :error="errors[0]"
                label="Efectivo:"
                :max-date="maxDate"
                :min-date="minDate"
                placeholder="DD/MM/YYYY"
              />
            </validation-provider>
          </div>
          <div class="col-md-2">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-date-picker
                v-model="model.discussionMinutesDate"
                class="w-100"
                custom-error-msg="Favor seleccionar la fecha discusión minuta."
                :error="errors[0]"
                label="Fecha Discusión Minuta:"
                :max-date="maxDate"
                :min-date="minDate"
                placeholder="DD/MM/YYYY"
              />
            </validation-provider>
          </div>
          <div class="col-md-5">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-drop-down
                v-model="model.selectedReason"
                custom-error-msg="Favor seleccionar la razón."
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Razón:"
                :options="reasons"
                placeholder="Seleccione"
              />
            </validation-provider>
          </div>
          <div v-if="showReasonComment" class="col-md-5 offset-md-5 mt-1">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-text-area
                id="txtCommentDenyPayment"
                v-model="model.dropReasonComment"
                custom-error-msg="Favor escribir un comentario."
                :error="errors[0]"
                label="Razón que limita el ofrecimiento:"
                :maxlength="500"
                show-char-count
              />
            </validation-provider>
          </div>
          <div v-if="showRecommendationsComment" class="col-md-12 mt-4">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-text-area
                id="txtRecommendationsComment"
                v-model="model.recommendationsComment"
                :count-classes="['d-block', 'small-counter', 'text-right']"
                custom-error-msg="Favor de documentar las recomendaciones para la escuela y hogar."
                :error="errors[0]"
                label="Recomendaciones para la escuela y hogar (plan de seguimiento):"
                :maxlength="3000"
                show-char-count
              />
            </validation-provider>
          </div>
          <div class="col-md-12 mt-4">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-text-area
                id="txtResult"
                v-model="model.results"
                :count-classes="['d-block', 'small-counter', 'text-right']"
                custom-error-msg="Favor escribir los resultados."
                :error="errors[0]"
                label="Resultados:"
                :maxlength="3000"
                show-char-count
              />
            </validation-provider>
          </div>
        </div>
        <div v-if="showLocationFields" class="row mt-3 ml-2">
          <div class="col-md-12">
            <hr />
          </div>
          <div class="col">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-drop-down
                v-model="model.selectedMunicipality"
                custom-error-msg="Favor seleccionar municipio."
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Municipio:"
                :options="municipalities"
                placeholder="Seleccione"
                @input="onMunicipalityChange"
              />
            </validation-provider>
          </div>
          <div class="col">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-drop-down
                v-model="model.selectedLocation"
                custom-error-msg="Favor seleccionar lugar de servicio."
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Lugar de Servicio:"
                :options="locations"
                placeholder="Seleccione"
                @input="onLocationChange"
              />
            </validation-provider>
          </div>
          <div class="col">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-drop-down
                v-model="model.selectedSpecialist"
                custom-error-msg="Favor seleccionar especialista."
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Especialista:"
                :options="specialists"
                placeholder="Seleccione"
              />
            </validation-provider>
          </div>
        </div>
        <div v-if="!showLocationFields" class="mt-5">
          <section-title has-line title="Documentos Anejados" />
          <div
            v-for="(item, index) in requiredDocuments"
            :key="`document-row-${index}`"
            class="row bg-secondary-3 rounded p-3 mb-3 ml-1 mr-0"
          >
            <div class="col-md-6">
              <div class="color-gray-6 font-14 font-weight-normal">
                Tipo de Documento:
              </div>
              <div class="color-black font-16 font-weight-normal">
                {{ item.documentTypeName }}
              </div>
            </div>
            <div class="col-md-6 d-flex justify-content-center">
              <div v-if="isDropTypeDocument(item)">
                <div v-if="hasDownloadedAdmissionTemplate">
                  <span
                    class="color-gray-6 font-14 font-weight-normal mr-3 mt-2"
                  >
                    Documento:
                  </span>
                  <validation-provider
                    v-slot="{ errors }"
                    :rules="{ required: item.isRequired }"
                  >
                    <custom-file-input
                      ref="attachedDocument"
                      v-model="item.selectedDocument"
                      :accept="'.pdf'"
                      :attachment-id="item.documentId"
                      custom-error-msg="Favor de anejar un documento."
                      display-style="normal"
                      :error="errors[0]"
                      label-position="left"
                      required
                    />
                  </validation-provider>
                </div>
                <div v-else>
                  <action-button
                    :id="'admission-drop-type-template' + index"
                    class="bg-green border-green mt-1"
                    i="fas fa-file-download text-white mr-n1 pr-1"
                    @click="downloadAdmissionDropTypeTemplate"
                  />
                </div>
              </div>
              <div v-else>
                <span class="color-gray-6 font-14 font-weight-normal mr-3 mt-2">
                  Documento:
                </span>
                <validation-provider
                  v-slot="{ errors }"
                  :rules="{ required: item.isRequired }"
                >
                  <custom-file-input
                    ref="attachedDocument"
                    v-model="item.selectedDocument"
                    :accept="'.pdf'"
                    :attachment-id="item.documentId"
                    custom-error-msg="Favor de anejar un documento."
                    display-style="normal"
                    :error="errors[0]"
                    label-position="left"
                    required
                  />
                </validation-provider>
              </div>
            </div>
          </div>
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import { PageHeader } from '@/shared/components/PageHeader/index';
import SectionTitle from '@/components/common/page/SectionTitle';
import CustomDatePicker from 'custom-date-picker';
import CustomTextArea from 'CustomTextArea';
import {
  CustomRadio,
  CustomDropDown,
  CustomFileInput,
  Error,
} from '@/components/common';
import { SignPlan } from './components/sign-plan';

import {
  getAdmissionDropReasons as _getAdmissionDropReasons,
  getAdmissionManagementMunicipality as _getAdmissionManagementMunicipality,
  getAdmissionManagementLocation as _getAdmissionManagementLocation,
  getAdmissionManagementSpecialist as _getAdmissionManagementSpecialist,
  admissionManagement as _admissionManagement,
  getAdmissionManagementRequest as _getAdmissionManagementRequest,
  getAdmission as _getAddmiision,
  getAdmissionManagementDocuments as _getAdmissionManagementDocuments,
  getSaeeSri06Report as _getSaeeSri06Report,
} from '@/modules/shared/studentreferral.api';
import _generalApi from '@/modules/app/api';
import { serialize as objectToFormData } from 'object-to-formdata';

import { getSysparameterByNames as _getSysparameterByNames } from '@/modules/shared/sysparameter.api';
import sysparameterByNames from '@/utils/constants/sysParameterNames';

import {
  getSignatureHubInfo as _getSignatureHubInfo,
  removeSignatureHub as _removeSignatureHub,
} from '@/modules/signatureHub/api';
import { SignatureHubInfo } from '@quisit/signature-hub';

import alertMixin from '@/mixins/alert.mixin.js';
import AdmissionStatus from '@/utils/shared/constants/admissionStatus';
import AdmissionDropReasons from '@/utils/constants/admissionDropReasons';
import AdmissionDocumentTypes from '@/utils/constants/admissionDocumentTypes';
import roles from '@/utils/constants/roles.js';
import admissionDocumentTypes from '@/utils/constants/admissionDocumentTypes';
import signatureHubTypes from '@/utils/constants/signatureHubTypes.js';
const companies = Object.freeze({
  DepartamentoDeEducacion: '472',
});
const levels = Object.freeze({ Alta: 1, Baja: 2, Traslado: 3 });
const highLowDocumentTypeId = 100;
const digitalSignatureStatuses = Object.freeze({ Pendiente: 3, Firmado: 5 });

export default {
  name: 'AdmissionManagement',
  components: {
    PageHeader,
    SectionTitle,
    CustomRadio,
    CustomDatePicker,
    CustomDropDown,
    CustomFileInput,
    Error,
    CustomTextArea,
    SignPlan,
    SignatureHubInfo,
  },
  mixins: [alertMixin],
  props: {
    admissionId: {
      type: [String, Number],
      default: () => '',
    },
  },
  data: () => ({
    admission: {},
    savedModelCopy: [],
    isEditing: false,
    model: {
      selectedLevel: null,
      effectiveDate: null,
      discussionMinutesDate: null,
      selectedReason: null,
      selectedMunicipality: null,
      selectedLocation: null,
      selectedSpecialist: null,
      dropReasonComment: null,
      recommendationsComment: null,
      admissionId: null,
      results: null,
      documents: [],
      isElectronicSignature: null,
    },
    generalData: {
      referralNumber: null,
      serviceType: null,
      student: null,
      sie: null,
    },
    reasons: [],
    municipalities: [],
    locations: [],
    specialists: [],
    documents: [],
    companiesPilot: [],
    hasDownloadedAdmissionTemplate: false,
    isSignHubActive: false,
    signatureHubInfo: null,
  }),
  computed: {
    isReadOnly() {
      if (this.isSignHubActive) return this.showSignTab && !this.isEditing;
      return false;
    },
    isSpecialist() {
      return [roles.Especialista].includes(this.userRole);
    },
    effectiveDateFrom() {
      const result = this.admission?.dateFrom
        ? new Date(this.admission.dateFrom)
        : new Date();
      result.setHours(0, 0, 0, 0);

      return result;
    },
    showOnlyOneDate() {
      let result;

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      // si la fecha de hoy es mayor a la fecha de efectividad, se muestra el calendario hasta la fecha de hoy
      if (
        today > this.effectiveDateFrom &&
        today - this.effectiveDateFrom != 0
      ) {
        result = false; // muestra mas de un dia
      }
      // si la fecha de hoy es igual a la fecha de efectividad o es menor, se muestra solo un dia
      else {
        result = true;
      }

      return result;
    },
    minDate() {
      if (this.showOnlyOneDate) {
        const date = new Date(this.effectiveDateFrom);
        date.setDate(date.getDate() - 1); // para mostrar 1 sola fecha (la fecha de efectividad)
        return date;
      }

      return this.effectiveDateFrom;
    },
    maxDate() {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      // si la fecha de hoy es mayor a la fecha de efectividad, se muestra el calendario hasta la fecha de hoy
      return today > this.effectiveDateFrom ? today : this.effectiveDateFrom;
    },
    companyId() {
      let cmpnyId = this.$store.state['$_user'].user.profile.companyid;
      return cmpnyId == undefined
        ? []
        : this.$store.state['$_user'].user.profile.companyid?.split(',');
    },
    isSpecialistFromEducationDpt() {
      return (
        this.companyId.includes(companies.DepartamentoDeEducacion) &&
        this.isSpecialist
      );
    },
    pageConfig() {
      return {
        title: 'Manejo de Admisiones',
        icon: 'fas fa-user-tie',
        routes: ['Proveedor'],
      };
    },
    boardData() {
      return [
        [
          {
            label: 'Número Referido:',
            icon: 'fas fa-address-book',
            data: this.emptyText(this.admission.referralNumber),
          },
          {
            label: 'Tipo de Servicio:',
            icon: 'fas fa-address-book',
            data: this.emptyText(this.admission.disciplineName),
          },
          {
            label: 'Estudiante:',
            icon: 'fas fa-address-book',
            data: this.emptyText(this.admission.fullName),
          },
          {
            label: 'SIE:',
            icon: 'fas fa-address-book',
            data: this.emptyText(this.admission.studentSieId),
          },
        ],
      ];
    },
    rbOptions() {
      const items = [];
      if (this.admission.statusId != AdmissionStatus.Asignado) {
        items.push({ label: 'Alta', value: 1 });
      }

      items.push({ label: 'Baja', value: 2 });
      if (!this.isSpecialistFromEducationDpt && !this.hasPilotPermission) {
        items.push({ label: 'Traslado', value: 3 });
      }

      return items;
    },
    headerActionConfig() {
      return [
        {
          text: 'Guardar',
          icon: 'fas fa-save',
          variant: 'success',
          click: this.saveHandler,
          visible: !this.isElectronicPending && !this.completed,
        },
        {
          text: 'Editar',
          icon: 'fas fa-edit',
          variant: 'success',
          click: this.handleEdit,
          visible:
            this.model.admissionId !== null &&
            this.isSignHubActive &&
            !this.isElectronicPending &&
            !this.completed &&
            !this.isEditing &&
            !this.hasManuscriptDocUploaded &&
            !this.hasDownloadedAdmissionTemplate &&
            this.userHasPermissions('referral.managementAdmission.edit'),
        },
        {
          text: 'Cancelar',
          icon: 'fas fa-times-circle',
          variant: 'danger',
          click: () => {
            this.model = this.savedModelCopy;
            this.isEditing = false;
          },
          visible:
            !this.isElectronicPending && !this.completed && this.isEditing,
        },
      ];
    },
    selectedReasonId() {
      return this.model.selectedReason?.id;
    },
    showLocationFields() {
      return (
        this.isTransfer &&
        this.selectedReasonId == AdmissionDropReasons.TrasladoInterno &&
        !this.hasPilotPermission
      );
    },
    requiredDocuments() {
      this.documents.forEach((x) => {
        x.isRequired = this.isDocumentRequired(x);
        this.$set(x, 'isEditing', false); //for reactivity :)
      });
      if (!this.isSignHubActive) return this.documents;
      return this.documents.filter(
        (x) => x.documentTypeId !== highLowDocumentTypeId
      );
    },
    selectedDocuments() {
      return this.documents.filter(
        (x) => x.selectedDocument != undefined || x.selectedDocument != null
      );
    },
    showReasonComment() {
      return (
        this.selectedReasonId ==
        AdmissionDropReasons.CambioProgramaEscolarLimitanOfrecimiento
      );
    },
    showRecommendationsComment() {
      return (
        this.model.selectedLevel == levels.Alta ||
        this.model.selectedLevel == levels.Baja
      );
    },
    hasPilotPermission() {
      return this.companiesPilot.includes(this.admission.companyId);
    },
    isDropTypeDocument() {
      return (item) =>
        item.documentTypeId === admissionDocumentTypes.InformeAltaBajaSAEESR06;
    },
    showSignTab() {
      return this.isSignHubActive && this.model.admissionId;
    },
    hasSelectMechanisManuscript() {
      return this.model.isElectronicSignature === false;
    },
    hasSelectMechanismElectronic() {
      return this.model.isElectronicSignature === true;
    },
    hasManuscriptDocUploaded() {
      return this.model.documents.some(
        (x) => x.documentTypeId === highLowDocumentTypeId
      );
    },
    highLowInformDocument() {
      return this.documents.find(
        (x) => x.documentTypeId === highLowDocumentTypeId
      );
    },
    hasHighLowInformUploaded() {
      return (
        !!this.highLowInformDocument?.selectedDocument ||
        this.hasManuscriptDocUploaded
      );
    },
    isElectronicPending() {
      return (
        this.signatureHubInfo?.documentInfo?.documentStatusId ===
        digitalSignatureStatuses.Pendiente
      );
    },
    isElectronicSigned() {
      return (
        this.signatureHubInfo?.documentInfo?.documentStatusId ===
        digitalSignatureStatuses.Firmado
      );
    },
    isElectronicDisabled() {
      return [
        this.isElectronicSigned,
        this.isElectronicPending,
        this.hasManuscriptDocUploaded,
      ].includes(true);
    },
    completed() {
      if (!this.admission) return false;
      return [
        AdmissionStatus.NoVigenteAlta,
        AdmissionStatus.NoVigenteBajas,
        AdmissionStatus.NoVigenteTraslado,
      ].includes(this.admission.statusId);
    },
    isTransfer() {
      return Number(this.model.selectedLevel) === levels.Traslado;
    },
  },
  watch: {
    'model.isElectronicSignature': {
      handler(val, old) {
        this.handleSelectMechanism(val, old);
      },
    },
  },
  async mounted() {
    await this.getAdmissionInfo();
    await this.getAdmissionManagementDocuments();
    await this.getParameters();
    await this.getManagementRequest();

    if (this.isElectronicSigned && !this.completed)
      await this.saveHandler(true);
  },
  methods: {
    handleEdit() {
      this.savedModelCopy = Object.assign({}, this.model);
      this.isEditing = true;
    },
    back() {
      this.$router.push({ name: 'referral-search' });
    },
    emptyText(value) {
      return value == null || value == '' ? '-' : value;
    },
    async getSignatureHubInfo() {
      try {
        const { data } = await _getSignatureHubInfo(
          signatureHubTypes.HIGH_LOW_INFORM,
          Number(this.admissionId)
        );
        this.signatureHubInfo = data;
      } catch (error) {
        this.ShowToast(
          'Error',
          'No se pudo obtener la información de firma.',
          'error'
        );
      }
    },
    async handleConfigureSignatures() {
      if (this.model.isElectronicSignature && !this.isElectronicDisabled) {
        await this.saveHandler(false);
      }
      this.$router.push({
        name: 'SignatureHub',
        params: {
          typeId: signatureHubTypes.HIGH_LOW_INFORM,
          relatedId: this.admissionId,
          from: 'admissionManagement',
          fromData: {
            admissionId: this.admissionId,
          },
        },
      });
    },
    async getAdmissionInfo() {
      const { data } = await _getAddmiision(this.admissionId);
      this.admission = data;
    },
    async getManagementRequest() {
      if (!this.isSignHubActive) return;

      const { data } = await _getAdmissionManagementRequest(this.admissionId);
      if (!data) return;

      this.model.selectedLevel = data.dropTypeId;

      if (data.dropReasonId) {
        await this.onLevelChange();

        this.model.selectedReason = this.reasons.find(
          (x) => x.id == data.dropReasonId
        );
      }

      this.model.admissionId = data.admissionId;
      this.model.effectiveDate = data.requestDate;
      this.model.discussionMinutesDate = data.discussionMinutesDate;
      this.model.dropReasonComment = data.dropReasonComment;
      this.model.recommendationsComment = data.recommendationsComment;
      this.model.studentServiceId = data.studentServiceId;
      this.model.disciplineTypeId = data.disciplineTypeId;
      this.model.results = data.results;
      this.model.documents = data.documents ?? [];
      this.model.isElectronicSignature =
        data.isElectronicSignature ??
        (this.hasHighLowInformUploaded ? false : null);
      this.model.newAdmissionId = data.newAdmissionId;
      if (this.hasSelectMechanismElectronic) await this.getSignatureHubInfo();
    },
    async getAdmissionManagementDocuments() {
      await _getAdmissionManagementDocuments().then(({ data }) => {
        this.documents = data;
      });
    },
    async getParameters() {
      const { data } = await _getSysparameterByNames({
        parameterNames: [
          sysparameterByNames.SpecialistAvailabilityCalendarPilot,
          sysparameterByNames.ActiveSignHub,
        ],
      });

      this.companiesPilot = data
        .find(
          (x) =>
            x.name == sysparameterByNames.SpecialistAvailabilityCalendarPilot
        )
        .staticValue.split(',');
      this.companiesPilot = this.companiesPilot.map((x) => Number(x));

      this.isSignHubActive =
        data.find((x) => x.name == sysparameterByNames.ActiveSignHub)
          .staticValue === 'true';
    },
    async downloadAdmissionDropTypeTemplate() {
      const isValid = await this.$refs.admissionManagementRef.validate();
      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'No es posible descargar el documento hasta completar los campos requeridos.',
          'error'
        );
        return;
      }

      const payload = {
        admissionId: parseInt(this.admissionId),
        dropTypeId: parseInt(this.model.selectedLevel),
        dropReasonId: this.model.selectedReason?.id,
        requestDate: this.model.effectiveDate,
        discussionMinutesDate: this.model.discussionMinutesDate,
        dropReasonComment: this.model.dropReasonComment,
        recommendationsComment: this.model.recommendationsComment,
        provider: this.admission.providerName,
        specialistId: this.model.selectedSpecialist?.id,
        specialistName: this.model.selectedSpecialist?.name,
        locationFiscalYearId: this.model.selectedLocation?.id,
        studentServiceId: this.admission.studentServiceId,
        disciplineTypeId: this.admission.disciplineTypeId,
        results: this.model.results,
      };
      try {
        const { data } = await _getSaeeSri06Report(payload);
        await _generalApi.ConvertToBlob(data);
        this.hasDownloadedAdmissionTemplate = true;
      } catch (err) {
        this.ShowToast('', err.response.data.message || err.message, 'error');
      }
    },
    async downloadFileByType(documentTypeId) {
      const { documentId } = this.model.documents.find(
        (x) => x.documentTypeId == documentTypeId
      );

      await _generalApi.downloadDocument(documentId);
    },
    isDocumentRequired(docType) {
      let isRequired = false;

      if (
        docType.documentTypeId ===
        AdmissionDocumentTypes.CertificaciónMinutaSolicitandoCiberterapia
      ) {
        isRequired =
          this.selectedReasonId ==
          AdmissionDropReasons.OfrecimientoPresencialPadresDeseanServicioCiberterapia;
      } else if (
        docType.documentTypeId ===
        AdmissionDocumentTypes.HojaTrámiteSAEEUMESRCSEEUC08ab
      ) {
        isRequired =
          this.selectedReasonId ==
          AdmissionDropReasons.EstudianteTrasladaOtraCorporaciónSolicitudPadre;
      } else if (
        docType.documentTypeId ===
        AdmissionDocumentTypes.InformeAltaBajaSAEESR06
      ) {
        isRequired = !this.showLocationFields;
      }

      return isRequired;
    },
    async onLevelChange() {
      this.model.selectedReason = null;
      this.model.selectedMunicipality = null;
      this.model.selectedLocation = null;
      this.model.selectedSpecialist = null;
      await _getAdmissionDropReasons(
        this.model.selectedLevel,
        this.admission.statusId
      ).then(({ data }) => (this.reasons = data));
      if (this.isSpecialistFromEducationDpt) {
        this.reasons = this.reasons.filter(
          (x) => x.id != AdmissionDropReasons.TrasladoInterno
        );
      }
      if (this.isTransfer) {
        await _getAdmissionManagementMunicipality(
          this.admission.academicYearId,
          this.admission.companyId
        ).then(({ data }) => (this.municipalities = data));
      }
    },
    async onMunicipalityChange() {
      this.model.selectedLocation = null;
      this.model.selectedSpecialist = null;
      await _getAdmissionManagementLocation(
        this.admission.academicYearId,
        this.admission.companyId,
        this.model.selectedMunicipality.id
      ).then(({ data }) => (this.locations = data));
    },
    async onLocationChange() {
      this.model.selectedSpecialist = null;
      await _getAdmissionManagementSpecialist(
        this.model.selectedLocation.id,
        this.admission.disciplineTypeId,
        this.admissionId
      ).then(({ data }) => (this.specialists = data));
    },
    async saveHandler(navigateOut = true) {
      const isValid = await this.$refs.admissionManagementRef.validate();
      if (!isValid) {
        this.ShowToast('Alerta', 'Información Incompleta', 'error');
        return;
      }

      if (
        !this.isTransfer &&
        (this.hasHighLowInformUploaded || this.isElectronicSigned)
      ) {
        const level = this.model.selectedLevel == levels.Alta ? 'Alta' : 'Baja';
        const answer = await this.ShowCancelModal(
          'Atención',
          `Al realizar el proceso de <strong>${level}</strong> no va a poder realizar ninguna modificación posterior como documentar Plan de Intervención y completar la Nota de Admisión. ¿Esta seguro que desea continuar con el proceso de realizar de <strong>${level}</strong>?`,
          'Sí',
          'No'
        );
        if (!answer) {
          return;
        }
      }

      let management = objectToFormData(
        {
          admissionId: this.admissionId,
          dropTypeId: parseInt(this.model.selectedLevel),
          dropReasonId: this.model.selectedReason.id,
          dropReasonComment: this.model.dropReasonComment,
          recommendationsComment: this.model.recommendationsComment,
          specialistId: this.model.selectedSpecialist?.id,
          specialistName: this.model.selectedSpecialist?.name,
          locationFiscalYearId: this.model.selectedLocation?.id,
          requestDate: this.model.effectiveDate,
          discussionMinutesDate: this.model.discussionMinutesDate,
          studentServiceId: this.admission.studentServiceId,
          files: this.showLocationFields ? null : this.selectedDocuments,
          disciplineTypeId: this.admission.disciplineTypeId,
          results: this.model.results,
          isElectronicSignature: this.model.isElectronicSignature,
          documents: this.model.documents,
          isElectronicSigned:
            this.model.isElectronicSignature && this.isElectronicSigned,
        },
        { indices: true, nullsAsUndefineds: true }
      );

      await _admissionManagement(management)
        .then((res) => {
          if (res.data) {
            if (!navigateOut) return;
            this.ShowToast(
              '',
              'Los cambios fueron guardados exitosamente.',
              'success'
            );
            if (
              !this.isTransfer &&
              this.isSignHubActive &&
              !this.hasHighLowInformUploaded &&
              !this.isElectronicSigned
            ) {
              this.$router.go(0);
            } else {
              this.back();
            }
          }
        })
        .catch((error) => {
          this.ShowToast('', error.response.data.message, 'error');
        });
    },
    async handleSelectMechanism(value, previousValue) {
      const toManuscript = value === false && previousValue === true;
      const toElectronic = value === true && previousValue === false;

      if (toElectronic && this.highLowInformDocument?.selectedDocument)
        await this.setToElectronic();
      else if (toManuscript && this.signatureHubInfo?.signatureHubId) {
        const result = await this.setToManuscript();
        if (result) await this.getSignatureHubInfo();
      }
    },
    async setToElectronic() {
      const confirmed = await this.ShowCancelModal(
        'Confirmación',
        'Usted ya se encuentra en un proceso de configuración de firma Manuscrito. ¿Está seguro que desea cambiar la configuración a Electronica?',
        'Sí',
        'No'
      );
      if (!confirmed) {
        this.model.isElectronicSignature = false;
        this.$nextTick(() => this.$refs.highLowInform.loadFile());
        return false;
      }
      this.highLowInformDocument.selectedDocument = null;
      return true;
    },
    async setToManuscript() {
      const confirmed = await this.ShowCancelModal(
        'Confirmación',
        'Usted ya se encuentra en un proceso de configuración de firma digital. ¿Está seguro que desea cambiar la configuración a manuscrito?',
        'Sí',
        'No'
      );

      if (!confirmed) {
        this.model.isElectronicSignature = true;
        return false;
      }
      try {
        await _removeSignatureHub(
          signatureHubTypes.HIGH_LOW_INFORM,
          this.admissionId
        );
        return true;
      } catch (error) {
        this.ShowToast('', error.response.data.message, 'error');
        return false;
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';

.border-green {
  border-color: map-get($colors, 'green');
}

::v-deep .custom-nav-container {
  border-bottom: 1px solid #e1e1e1;
  .nav-item .nav-link {
    font-size: 17.6px;
    font-weight: 700;
    &.active {
      border-bottom: 3px solid #2db782;
      color: #2db782;
    }
  }
}
</style>
